export const config = {
  auth: {
    clientId: import.meta.env.VITE_AZURE_AD_CLIENT_ID,
    authority: import.meta.env.VITE_AZURE_AD_AUTHORITY,
  },
  api: {
    scope: import.meta.env.VITE_API_SCOPE,
  },
  applicationInsights: {
    instrumentationKey: import.meta.env.VITE_AI_INSTRUMENTATION_KEY,
  },
};
